enum CreditCardProvider {
	Undefined = 0,
	CreditCall = 1,
	IECISA = 2,
	ElavonSantanderRAW = 3,
	Stripe = 4,
	Moneris = 5,
	Transbank = 6,
	PayU = 7,
	PayPal = 8,
	NiIdea = 9,
	DebitCreditCard = 10,
	MercadoPago = 11,
	Windcave = 13
}

export default CreditCardProvider;
